import './EmptyState.css';

export default function EmptyState({ type = 'events', title, children }) {
    const isGallery = type === 'gallery';

    return (
        <div className={`empty-state empty-state-${type}`} role="status">
            <div className="empty-state-ornament" aria-hidden="true">
                <span></span>
                <div className="empty-state-icon">
                    {isGallery ? (
                        <svg viewBox="0 0 48 48" fill="none">
                            <rect x="7" y="9" width="34" height="30" rx="7" stroke="currentColor" strokeWidth="2" />
                            <circle cx="17" cy="19" r="3" stroke="currentColor" strokeWidth="2" />
                            <path d="M10 34l9-9 7 7 5-5 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    ) : (
                        <svg viewBox="0 0 48 48" fill="none">
                            <rect x="8" y="11" width="32" height="29" rx="7" stroke="currentColor" strokeWidth="2" />
                            <path d="M15 7v8M33 7v8M8 20h32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            <path d="M17 28h14M17 33h9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    )}
                </div>
                <span></span>
            </div>
            <h3>{title}</h3>
            {children && <p>{children}</p>}
        </div>
    );
}
